// Custom Imports
// =========================================================
import { FormatKey } from 'src/app/utils/global_functions'
import { CellClassRules } from '../02_global-settings/cell-class-rules'
import { GenerateDefaultColDefs } from '../02_global-settings/global-cell-formatter'
import { type ValueFormatterParams } from 'ag-grid-community'
import { RecoBuyQtySubmitDeliveriesCellRenderer } from '../03_custom-components/reco-buy-qty-submit-deliveries-cell-renderer/reco-buy-qty-submit-deliveries-cell-renderer.component'

export interface RecoBuyQtySubmit_GridDataParams {
  mainColDefs: any[]
  // detialColDefs: any[];
}

export async function RecoBuyQtySubmit_GenerateGridData (params: RecoBuyQtySubmit_GridDataParams) {
  const {
    mainColDefs
    // detailColDefs
  } = params

  const GenerateCols = async (data: any[], gridToRender: string) => {
    const mappedCols = {}

    Object.entries(data).map(([colKey, colVal]) => {
      const colId = colVal.refData?.custom_field || FormatKey(colKey)

      const obj = {
        ...GenerateDefaultColDefs(colKey, { colId, ...colVal })
      }
      Object.assign(mappedCols, {
        [obj.colId]: RecoBuyQtySubmit_customCellFormatting(obj, gridToRender)
      })
    })

    return Object.values(mappedCols)
  }

  const getResults = async () => {
    const mainCols = await GenerateCols(mainColDefs, 'main')

    const results = await Promise.all([mainCols])
    const m = results.indexOf(mainCols)

    const data = {
      mainColDefs: results[m]
    }
    return data
  }
  return await getResults()
}

export const RecoBuyQtySubmit_customCellFormatting = (col, gridToRender) => {
  const hasValue = val => val && ((val !== '' && val !== undefined) || val !== null)
  const getParams = () => {
    // Main Grid Settings
    if (gridToRender === 'main') {
      switch (col.colId) {
        case 'deliveries':
          return {
            cellRenderer: RecoBuyQtySubmitDeliveriesCellRenderer
          }
        default:
          return {
            valueFormatter: (params: ValueFormatterParams) => params.value
          }
      }
    }
  }
  const updatedCol = {
    ...col,
    ...getParams(),
    cellClassRules: {
      ...CellClassRules
    }
  }
  return updatedCol
}
